<div class="card">
  <div class="card-header bg-white">
    <h3>
      Dados de cadastro
    </h3>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-12 col-lg-6 p-2">
        <label for="cliente">Unidade Cliente</label>
        <select [formControl]="form.controls.cliente" id="cliente" name="cliente" class="form-control  input-validate">
          <option *ngFor="let r of listaUnidadesClientes" [ngValue]="r">{{r.nomeFantasia}}</option>
        </select>
        <app-msg-erro [control]="form.controls.cliente"></app-msg-erro>
      </div>
      <div class="col-12 col-lg-6 p-2">
        <label for="auditor">Auditor(a)</label>
        <select [formControl]="form.controls.auditor" id="auditor" class="form-control input-validate">
          <option *ngFor="let r of listaUnidadesAuditora" [value]="r.id">{{r.nome}}</option>
        </select>
        <app-msg-erro [control]="form.controls.auditor"></app-msg-erro>
      </div>
      <div class="col-12 col-lg-12 p-2 bg-white d-flex justify-content-end">
        <button type="button" (click)="sendForm()" class="btn btn-lg px-5 btn-success"><span>Confirmar</span></button>
      </div>
    </div>
  </div>
</div>